module.exports = __webpack_public_path__ + "static/media/pencil.a9477557.svg";